import { Component, EventEmitter, Input, Output } from '@angular/core';

import { GridColumn } from '../../models/grid-column';

/**
 * This component displays an infinite scroll table. When scrolling down, the event loadMoreData will be emitted.
 */
@Component({
    selector: 'cw-infinite-scroll-table',
    templateUrl: './infinite-scroll-table.component.html',
    styleUrls: ['./infinite-scroll-table.component.scss'],
    standalone: false,
})
export class InfiniteScrollTableComponent {
    /** The columns configuration that you show on your table. The columns are set programatically. */
    @Input() columns: GridColumn[] = [];

    /** Data to be displayed in the body of the table.*/
    @Input() data: any[] = [];

    /** Displays loader when isLoaging is true */
    @Input() isLoading = false;

    /** This event is emitted when the table needs load more data */
    @Output() loadMoreData = new EventEmitter();

    onLoadMoreData(): void {
        this.loadMoreData.emit();
    }
}
